import { render, staticRenderFns } from "./CadastroTarefaGrupo.vue?vue&type=template&id=5764598f&scoped=true&"
import script from "./CadastroTarefaGrupo.vue?vue&type=script&lang=js&"
export * from "./CadastroTarefaGrupo.vue?vue&type=script&lang=js&"
import style0 from "./CadastroTarefaGrupo.vue?vue&type=style&index=0&id=5764598f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5764598f",
  null
  
)

export default component.exports